
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Opprett dashbord',
	'dashboard': 'Dashbord',
	'dashboardTemplate': 'Dashbordmal',
	'createAV': 'Opprett',
	'createAvEditNameLabel': '1. Gi visningen et navn',
	'createAvSelectTemplateLabel': '2. Velg en mal',
	'tabLayoutLabel': 'Mal med flipper',
	'infographicsLayoutLabel': 'Infografikkmal',
	'singlePageLayoutLabel': 'Enkeltsidemal',
	'customLayoutLabel': 'Tilpasset mal',
	'freeformTemplate': 'Fritt format',
	'freeformTemplateDesc': 'Visualiseringer i en layout med fritt format vises nøyaktig slik du plasserer dem i visningen, og med den størrelsen du velger, uansett skjermstørrelse. I andre layouter blir størrelsen på og plasseringen av visualiseringer justert slik at de passer på skjermen.',
	'NoTemplate': 'Fritt format',
	'Template1': 'Blank',
	'Template2': 'Tittel 1 ganger 2',
	'Template3': '2 over 1',
	'Template4': '4 over 1',
	'Template5': 'Bunntekst 1 ganger 2',
	'Template6': '3 ved siden av 1 over 1',
	'Template7': '4 ved siden av 3 over 1',
	'Template8': '2 over 3 ganger 2',
	'Template9': '2 ganger 2',
	'Template10': '1 ganger 2 ved siden av 2 ganger 2 over 1',
	'Template11': '3 ganger 1 over 1 ganger 2',
	'Template12': '2 over 1 ved siden av 1 ganger 2',
	'Template13': 'En ved siden av 1 ganger 2 ved siden av 1 ganger 4',
	'Template14': 'Blank med slippsone',
	'Infographics1': 'Blank',
	'Infographics2': '4 rader',
	'Infographics3': '4 rader med overskrifter',
	'Infographics4': '2 ganger 4',
	'Infographics5': 'Stor toppvisning med 2 ganger 2',
	'Infographics6': '2 ganger 4 med loddrett mellomrom',
	'Infographics7': '2 ganger 4 forskjøvet',
	'Infographics8': 'Tennisbane',
	'Infographics9': '3 ganger 4',
	'Infographics10': '4 ganger 8',
	'createAvDashboardLabel': 'Layout',
	'dashboard_template_save_success': 'Dashbordmalen er lagret.',
	'dashboard_template_prefix': 'Mal: \'%{name}\'',
	'dashboard_template_filters_removed': 'Filtre på lerretet er fjernet.',
	'createAvTabLabel': 'Med flipper',
	'createAvInfographicsLabel': 'Infografikk',
	'createAvSinglepageLabel': 'Enkeltside',
	'createAvCustomLabel': 'Tilpasset',
	'loadMoreLabel': 'Last inn mer...',
	'backLabel': 'Gå tilbake',
	'addSourceLabel': 'Legg til en kilde',
	'pinLabel': 'Fest',
	'errorLoadingDataSetMetaData': 'Det oppstod en feil ved lesing av metadataene',
	'errorLoadingDataSets': 'Det oppstod en feil ved lasting av listen med datasett',
	'errorLoadingDataSet': 'Metadataene for datasettet \'%{datasetName}\' ble ikke lastet inn. Kontakt administratoren for å få mer informasjon.',
	'okButton': 'OK',
	'createButton': 'Opprett',
	'cancelButton': 'Avbryt',
	'copyButton': 'Kopier',
	'selectTemplateLabel': 'Velg en mal',
	'noSourcesSelectedLabel': 'Ingen kilder valgt',
	'find_label': 'Søk',
	'noDashboardFound': 'Dashbordet kan ikke hentes. Det finnes ikke lenger, eller du har ikke nok rettigheter til å vise det.',
	'errorLabel': 'Feil',
	'defaultName': 'Nytt dashbord',
	'noDashboardCapability': 'Du har ikke mulighet til å kjøre dashbordapplikasjonen',
	'noCapabilityForEdit': 'Du har ikke mulighet til å redigere dette dashbordet',
	'noCapabilityForSave': 'Du har ikke mulighet til å lagre dette dashbordet',
	'noCapabilityForPaste': 'Du har ikke mulighet til å lime inn kopierte widgeter i denne visningen',
	'noCapabilityForPin': 'Du har ikke mulighet til å legge til denne festingen',
	'noDashboardPermission': 'Du har ikke tilstrekkelige rettigheter til å vise dette dashbordet',
	'sourceNotFound': 'Vi kan ikke laste inn visualiseringen, fordi den tilknyttede kilden \'%{sourceName}\' ikke er tilgjengelig',
	'cmDuplicateName': 'Det finnes allerede et element med dette navet. Prøv et annet navn',
	'cmEmptySelection': 'Dashbordet er slettet. Prøv å lagre som et nytt dashbord.',
	'propTheme': 'Visuelt tema',
	'defaultThemeLabel': 'Standard',
	'lightThemeLabel': 'Lys',
	'darkThemeLabel': 'Mørk',
	'titleTextLabel': 'Tittel',
	'titleSmallTextLabel': 'Tittel liten',
	'subtitleTextLabel': 'Undertittel',
	'bodyTextLabel': 'Hoveddel',
	'bodySmallTextLabel': 'Hovedtekst liten',
	'captionTextLabel': 'Tittel',
	'quoteTextLabel': 'Sitat',
	'quoteSmallTextLabel': 'Sitat lite',
	'responsiveTextLabel': 'Autostørrelse',
	'mediaWidgetLabel': 'Media',
	'webpageWidgetLabel': 'Webside',
	'imageWidgetLabel': 'Bilde',
	'textWidgetLabel': 'Tekst',
	'notebookWidgetLabel': 'Notisbok',
	'multipurposeWidgetLabel': 'Flerfunksjon',
	'textPlaceHolder': 'Skriv teksten din her',
	'titlePlaceHolder': 'Skriv tittelen din her',
	'toggleEditModeLabel': 'Bytt til redigering',
	'togglePreviewModeLabel': 'Bytt til forhåndsvisning',
	'editDashboardCoachMarkTitle': 'Rediger dashbord',
	'editDashboardCoachMarkContents': 'Klikk på blyantikonet for å redigere dette dashbordet.',
	'addDataCoachMarkTitle': 'Legg til data',
	'addDataDashboardCoachMarkContents': 'Dra og slipp data fra datapanelet til dashbordet.',
	'pageSelectWarning': 'Velg en flipp.',
	'screenshot_label': 'Dashbord %{title}',
	'screenshot_label_tab': 'Flipp %{tabName} på dashbord %{title}',
	'dataAssetPropertiesLabel': 'Visualiseringsegenskaper',
	'modelFilter': 'Filter',
	'invertSelectionToolTip': 'Inverter filtervalg',
	'clearFilterValueToolTip': 'Tøm filterverdier',
	'invertFilterSelection': 'Inverter',
	'clearTextFilterValue': 'Tøm',
	'filterConditionLabel': 'Filterbetingelse',
	'applyFilter': 'Bruk filter',
	'itemCountText': '%{itemCount} element(er) valgt',
	'itemExcludeCountText': '%{itemCount} element(er) ekskludert',
	'moreMembers': 'Vis mer...',
	'searchHierarchyMembers': 'Bruk søk for å finne medlemmer...',
	'propHideEmpty': 'Skjul tomme',
	'propColorOrder': 'Fargerekkefølge',
	'propElementColor': 'Farge på visualiseringselement',
	'propLineColor': 'Linjefarge',
	'propLineAndSymbolColor': 'Linje- og symbolfarge',
	'propColumnColor': 'Kolonnefarge',
	'propBarColor': 'Stolpefarge',
	'propWordColor': 'Ordfarge',
	'propAreaColor': 'Områdefarge',
	'propRadialbarColor': 'Radialstolpefarge',
	'propColorPalettes': 'Fargepaletter',
	'propDashboardColorPalette': 'Gjeldende dashbordpalett',
	'propNewDashboardPaletteLabel': 'Opprett en tilpasset dashbordpalett',
	'propDashboardChangePaletteLink': 'Endre dashbordpalett',
	'propHideLeafNode': 'Skjul bladetiketter',
	'propOpacity': 'Ugjennomsiktighet',
	'propOpacityDescription': 'Gjør objektet mer eller mindre ugjennomsiktig. Skriv en verdi mellom 0 og 100',
	'addATab': 'Legg til en ny flipp',
	'propFredIsRed': 'Fargekonsistens',
	'areaChartCaption': 'Område',
	'areaChartDataSlot_categoriesLabel': 'Akseetikett',
	'areaChartDataSlot_valuesLabel': 'Verdi',
	'areaChartProp_colorPaletteLabel': 'Fargepaletter',
	'areaChartProp_lineColorLabel': 'Områdefarge',
	'areaChartProp_interpolationLabel': 'Jevne linjer',
	'areaChartProp_interpolationDescription': 'Linjer som knytter sammen datapunkter, er buet.',
	'areaChartProp_hideGridLinesLabel': 'Skjul rutenettlinjer',
	'areaChartProp_hideGridLinesDescription': 'Skjul rutenettlinjer',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetitteletiketter',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Skjul titlene for aksene.',
	'areaChartProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'areaChartProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'areaChartProp_suppressZerosLabel': 'Skjul tomme',
	'areaChartProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'barChartCaption': 'Stolpe',
	'barChartDataSlot_categoriesLabel': 'Akseetikett',
	'barChartDataSlot_valuesLabel': 'Verdi',
	'barChartProp_colorPaletteLabel': 'Fargepaletter',
	'barChartProp_elementColorLabel': 'Stolpefarge',
	'barChartProp_hideGridLinesLabel': 'Skjul rutenettlinjer',
	'barChartProp_hideGridLinesDescription': 'Skjul rutenettlinjer',
	'barChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetitteletiketter',
	'barChartProp_hideAxisTitleLabelsDescription': 'Skjul titlene for aksene.',
	'barChartProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'barChartProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'barChartProp_suppressZerosLabel': 'Skjul tomme',
	'barChartProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'columnChartCaption': 'Kolonne',
	'columnChartDataSlot_categoriesLabel': 'Akseetikett',
	'columnChartDataSlot_valuesLabel': 'Verdi',
	'columnChartProp_colorPaletteLabel': 'Fargepaletter',
	'columnChartProp_elementColorLabel': 'Kolonnefarge',
	'columnChartProp_hideGridLinesLabel': 'Skjul rutenettlinjer',
	'columnChartProp_hideGridLinesDescription': 'Skjul rutenettlinjer',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetitteletiketter',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Skjul titlene for aksene.',
	'columnChartProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'columnChartProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'columnChartProp_suppressZerosLabel': 'Skjul tomme',
	'columnChartProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'bubbleChartCaption': 'Boble',
	'bubbleChartDataSlot_xAxisLabel': 'Vannrett akse',
	'bubbleChartDataSlot_yAxisLabel': 'Loddrett akse',
	'bubbleChartDataSlot_sizeLabel': 'Størrelse etter',
	'bubbleChartDataSlot_colorLabel': 'Farge etter',
	'bubbleChartProp_colorPaletteLabel': 'Fargepaletter',
	'bubbleChartProp_hideGridLinesLabel': 'Skjul rutenettlinjer',
	'bubbleChartProp_hideGridLinesDescription': 'Skjul rutenettlinjer',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetitteletiketter',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Skjul titlene for aksene.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'bubbleChartProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'bubbleChartProp_hideLegendLabel': 'Skjul forklaring',
	'bubbleChartProp_hideLegendDescription': 'Skjul forklaringen.',
	'bubbleChartProp_legendPositionLabel': 'Posisjon for forklaring',
	'lineChartCaption': 'Linje',
	'lineChartDataSlot_categoriesLabel': 'Akseetikett',
	'lineChartDataSlot_valuesLabel': 'Verdi',
	'lineChartProp_colorPaletteLabel': 'Fargepaletter',
	'lineChartProp_lineColorLabel': 'Linje- og symbolfarge',
	'lineChartProp_symbolShapeLabel': 'Symbolform',
	'lineChartProp_hideSymbolsLabel': 'Skjul symboler',
	'lineChartProp_hideSymbolsDescription': 'Skjul symboler',
	'lineChartProp_hideDataLinesLabel': 'Skjul linje(r)',
	'lineChartProp_hideDataLinesDescription': 'Skjul linje(r)',
	'lineChartProp_interpolationLabel': 'Jevne linjer',
	'lineChartProp_interpolationDescription': 'Linjer som knytter sammen datapunkter, er buet.',
	'lineChartProp_hideGridLinesLabel': 'Skjul rutenettlinjer',
	'lineChartProp_hideGridLinesDescription': 'Skjul rutenettlinjer',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetitteletiketter',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Skjul titlene for aksene.',
	'lineChartProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'lineChartProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'lineChartProp_suppressZerosLabel': 'Skjul tomme',
	'lineChartProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'packedBubbleChart1CatCaption': 'Pakket boble',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Kategorier',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Størrelse etter',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Fargepaletter',
	'packedBubbleChart1CatProp_elementColorLabel': 'Boblefarge',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Skjul etikett',
	'packedBubbleChart1CatProp_hideValueLabel': 'Skjul verdi',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Skjul tomme',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'heatChartCaption': 'Varme',
	'heatChartDataSlot_valuesLabel': 'Varme etter',
	'heatChartDataSlot_xAxisLabel': 'Vannrett akse',
	'heatChartDataSlot_yAxisLabel': 'Loddrett akse',
	'heatChartProp_colorPaletteLabel': 'Fargepaletter',
	'heatChartProp_heatScalePaletteLabel': 'Fargerekkefølge',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetitteletiketter',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Skjul titlene for aksene.',
	'heatChartProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'heatChartProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'heatChartProp_suppressZerosLabel': 'Skjul tomme',
	'heatChartProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'heatChartProp_hideLegendLabel': 'Skjul forklaring',
	'heatChartProp_hideLegendDescription': 'Skjul forklaringen.',
	'heatChartProp_legendPositionLabel': 'Posisjon for forklaring',
	'pieChartCaption': 'Sektor',
	'pieChartDataSlot_categoriesLabel': 'Kategorier',
	'pieChartDataSlot_valuesLabel': 'Verdi',
	'pieChartProp_colorPaletteLabel': 'Fargepaletter',
	'pieChartProp_hideRadialValueLabel': 'Skjul verdi',
	'pieChartProp_pieAsDonutLabel': 'Vis som smultringdiagram',
	'pieChartProp_pieAsDonutDescription': 'Vis som smultringdiagram',
	'pieChartProp_suppressZerosLabel': 'Skjul tomme',
	'pieChartProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'pieChartProp_hideLegendLabel': 'Skjul forklaring',
	'pieChartProp_hideLegendDescription': 'Skjul forklaringen.',
	'pieChartProp_legendPositionLabel': 'Posisjon for forklaring',
	'map1measureCaption': 'Kart',
	'map1measureDataSlot_categoriesLabel': 'Regioner',
	'map1measureDataSlot_valuesLabel': 'Regionvarme',
	'map1measureProp_colorPaletteLabel': 'Fargepaletter',
	'map1measureProp_heatScalePaletteLabel': 'Fargerekkefølge',
	'map1measureProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'map1measureProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'map1measureProp_suppressZerosLabel': 'Skjul tomme',
	'map1measureProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'map1measureProp_hideLegendLabel': 'Skjul forklaring',
	'map1measureProp_hideLegendDescription': 'Skjul forklaringen.',
	'map1measureProp_legendPositionLabel': 'Posisjon for forklaring',
	'radialChartCaption': 'Radial',
	'radialChartDataSlot_categoriesLabel': 'Kategorier',
	'radialChartDataSlot_valuesLabel': 'Verdi',
	'radialChartProp_colorPaletteLabel': 'Fargepaletter',
	'radialChartProp_elementColorLabel': 'Radialstolpefarge',
	'radialChartProp_hideRadialTitleLabel': 'Skjul tittel',
	'radialChartProp_hideRadialValueLabel': 'Skjul verdi',
	'radialChartProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'radialChartProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'radialChartProp_suppressZerosLabel': 'Skjul tomme',
	'radialChartProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'pointChart1catCaption': 'Punkt',
	'pointChart1catDataSlot_valuesLabel': 'Verdi',
	'pointChart1catDataSlot_categoriesLabel': 'Akseetikett',
	'pointChart1catProp_colorPaletteLabel': 'Fargepaletter',
	'pointChart1catProp_elementColorLabel': 'Formfarge',
	'pointChart1catProp_symbolShapeLabel': 'Symbolform',
	'pointChart1catProp_symbolFillLabel': 'Fyllform',
	'pointChart1catProp_symbolFillDescription': 'Vis fyllfargen for symbolene.',
	'pointChart1catProp_hideGridLinesLabel': 'Skjul rutenettlinjer',
	'pointChart1catProp_hideGridLinesDescription': 'Skjul rutenettlinjer',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Skjul aksetitteletiketter',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Skjul titlene for aksene.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'pointChart1catProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'pointChart1catProp_suppressZerosLabel': 'Skjul tomme',
	'pointChart1catProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'scatterPlotChartNoCatCaption': 'Spredningsdiagram',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Vannrett akse',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Loddrett akse',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Fargepaletter',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Elementfarge',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Symbolform',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Fyllform',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Vis fyllfargen for symbolene.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Skjul rutenettlinjer',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Skjul rutenettlinjer',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Skjul aksetitteletiketter',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Skjul titlene for aksene.',
	'radialBarChartCaption': 'Radialstolpe',
	'radialBarChartDataSlot_categoriesLabel': 'Kategorier',
	'radialBarChartDataSlot_valuesLabel': 'Verdi',
	'radialBarChartProp_colorPaletteLabel': 'Fargepaletter',
	'radialBarChartProp_elementColorLabel': 'Radialstolpefarge',
	'radialBarChartProp_hideRadialTitleLabel': 'Skjul tittel',
	'radialBarChartProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'radialBarChartProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'radialBarChartProp_suppressZerosLabel': 'Skjul tomme',
	'radialBarChartProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'lineColumnComboChartCaption': 'Linje og kolonne',
	'lineColumnComboChartDataSlot_categoryLabel': 'Akseetikett',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Linjeverdi',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Kolonneverdi',
	'lineColumnComboChartProp_colorPaletteLabel': 'Fargepaletter',
	'lineColumnComboChartProp_elementColorLabel': 'Kolonnefarge',
	'lineColumnComboChartProp_lineColorLabel': 'Linje- og symbolfarge',
	'lineColumnComboChartProp_symbolShapeLabel': 'Symbolform',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Skjul symboler',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Skjul symboler',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Skjul linje(r)',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Skjul linje(r)',
	'lineColumnComboChartProp_interpolationLabel': 'Jevne linjer',
	'lineColumnComboChartProp_interpolationDescription': 'Linjer som knytter sammen datapunkter, er buet.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Skjul rutenettlinjer',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Skjul rutenettlinjer',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Skjul aksetitteletiketter',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Skjul titlene for aksene.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Skjul tomme',
	'lineColumnComboChartProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'lineColumnComboChartProp_hideLegendLabel': 'Skjul forklaring',
	'lineColumnComboChartProp_hideLegendDescription': 'Skjul forklaringen.',
	'lineColumnComboChartProp_legendPositionLabel': 'Posisjon for forklaring',
	'summaryCaption': 'Sammendrag',
	'areaName': 'Område',
	'areaDescription': 'Område',
	'areaDataSlot_colorLabel': 'Farge etter',
	'areaDataSlot_valuesLabel': 'Verdi',
	'areaDataSlot_categoriesLabel': 'Akseetikett',
	'bubbleName': 'Boble',
	'bubbleDescription': 'Boble',
	'bubbleDataSlot_yAxisLabel': 'Loddrett akse',
	'bubbleDataSlot_xAxisLabel': 'Vannrett akse',
	'bubbleDataSlot_sizeLabel': 'Størrelse etter',
	'bubbleDataSlot_colorLabel': 'Farge etter',
	'clusterBarName': 'Stolpe',
	'clusterBarDescription': 'Stolpe',
	'clusterBarDataSlot_colorLabel': 'Farge etter',
	'clusterBarDataSlot_valuesLabel': 'Verdi',
	'clusterBarDataSlot_categoriesLabel': 'Akseetikett',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Verdi',
	'clusterColumnName': 'Kolonne',
	'clusterColumnDescription': 'Kolonne',
	'clusterColumnDataSlot_colorLabel': 'Farge etter',
	'clusterColumnDataSlot_valuesLabel': 'Verdi',
	'clusterColumnDataSlot_categoriesLabel': 'Akseetikett',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Verdi',
	'clusterLineName': 'Linje',
	'clusterLineDescription': 'Linje',
	'clusterLineDataSlot_colorLabel': 'Farge etter',
	'clusterLineDataSlot_valuesLabel': 'Loddrett akse',
	'clusterLineDataSlot_categoriesLabel': 'Vannrett akse',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Verdi',
	'gridName': 'Rutenett',
	'gridDescription': 'Rutenett',
	'gridDataSlot_grid_colsLabel': 'Kolonne',
	'heatName': 'Varme',
	'heatDescription': 'Varme',
	'heatDataSlot_yAxisLabel': 'Loddrett akse',
	'heatDataSlot_xAxisLabel': 'Vannrett akse',
	'heatDataSlot_valuesLabel': 'Varme etter',
	'lineColumnComboName': 'Linje og kolonne',
	'lineColumnComboDescription': 'Linje og kolonne',
	'lineColumnComboDataSlot_lineValueLabel': 'Linjeverdi',
	'lineColumnComboDataSlot_categoryLabel': 'Akseetikett',
	'lineColumnComboDataSlot_columnValueLabel': 'Kolonneverdi',
	'mapName': 'Gammelt kart',
	'mapDescription': 'Gammelt kart',
	'mapDataSlot_sizeLabel': 'Punktstørrelse',
	'mapDataSlot_valuesLabel': 'Regionvarme',
	'mapDataSlot_sizeHeatLabel': 'Punktvarme',
	'mapDataSlot_categoriesLabel': 'Regioner',
	'packedBubbleName': 'Pakket boble',
	'packedBubbleDescription': 'Pakket boble',
	'packedBubbleDataSlot_sizeLabel': 'Størrelse etter',
	'packedBubbleDataSlot_colorLabel': 'Farge etter',
	'packedBubbleDataSlot_categoriesLabel': 'Kategorier',
	'pieName': 'Sektor',
	'pieDescription': 'Sektor',
	'pieDataSlot_valuesLabel': 'Verdi',
	'pieDataSlot_categoriesLabel': 'Kategorier',
	'playerName': 'Dataavspiller',
	'playerDescription': 'Dataavspiller',
	'playerDataSlot_categoriesLabel': 'Akseetikett',
	'pointName': 'Punkt',
	'pointDescription': 'Punkt',
	'pointDataSlot_colorLabel': 'Farge etter',
	'pointDataSlot_valuesLabel': 'Verdi',
	'pointDataSlot_categoriesLabel': 'Akseetikett',
	'radialName': 'Radial',
	'radialDescription': 'Radial',
	'radialDataSlot_valuesLabel': 'Verdi',
	'radialDataSlot_maxSizeLabel': 'Maksimumsverdi',
	'radialDataSlot_categoriesLabel': 'Kategorier',
	'radialBarName': 'Radialstolpe',
	'radialBarDescription': 'Radialstolpe',
	'radialBarDataSlot_valuesLabel': 'Verdi',
	'radialBarDataSlot_categoriesLabel': 'Kategorier',
	'scatterPlotName': 'Spredningsdiagram',
	'scatterPlotDescription': 'Spredningsdiagram',
	'scatterPlotDataSlot_yAxisLabel': 'Loddrett akse',
	'scatterPlotDataSlot_xAxisLabel': 'Vannrett akse',
	'scatterPlotDataSlot_colorLabel': 'Farge etter',
	'scatterPlotDataSlot_categoriesLabel': 'Punkter',
	'stackedBarName': 'Stablet stolpe',
	'stackedBarDescription': 'Stablet stolpe',
	'stackedBarDataSlot_colorLabel': 'Farge etter',
	'stackedBarDataSlot_valuesLabel': 'Verdi',
	'stackedBarDataSlot_categoriesLabel': 'Akseetikett',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Verdi',
	'stackedColumnName': 'Stablet kolonne',
	'stackedColumnDescription': 'Stablet kolonne',
	'stackedColumnDataSlot_colorLabel': 'Farge etter',
	'stackedColumnDataSlot_valuesLabel': 'Verdi',
	'stackedColumnDataSlot_categoriesLabel': 'Akseetikett',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Verdi',
	'summaryChartName': 'Sammendrag',
	'summaryChartDescription': 'Sammendrag',
	'summaryChartDataSlot_valuesLabel': 'Verdi',
	'treeMapName': 'Treoversikt',
	'treeMapDescription': 'Treoversikt',
	'treeMapDataSlot_colorLabel': 'Varme etter',
	'treeMapDataSlot_valuesLabel': 'Størrelse etter',
	'treeMapDataSlot_categoriesLabel': 'Nivå en',
	'treeMapDataSlot_level3Label': 'Nivå tre',
	'treeMapDataSlot_level2Label': 'Nivå to',
	'wordCloudName': 'Ordsky',
	'wordCloudDescription': 'Ordsky',
	'wordCloudDataSlot_colorLabel': 'Farge etter',
	'wordCloudDataSlot_scaleLabel': 'Størrelse etter',
	'wordCloudDataSlot_wordLabel': 'Ord',
	'treeMap1Cat1MeasureChartCaption': 'Treoversikt',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Nivå en',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Størrelse etter',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Fargepaletter',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Fargepaletter',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Fargepaletter',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Fargepaletter',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Fargepaletter',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Fargepaletter',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Skjul tomme',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Skjul forklaring',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Skjul forklaringen.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Posisjon for forklaring',
	'wordChart1Cat1MeasureCaption': 'Ordsky',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Ord',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Størrelse etter',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Fargepaletter',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Ordfarge',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Vedlikehold akseskala',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Vis alltid minimums- og maksimumverdiene på aksene.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Skjul tomme',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Skjul kategorier uten noen tilknyttede verdier.',
	'missingDataSetData': 'Dataene for dette datasettet er ikke tilgjengelige. Oppdater datasettet eller kontakt administratoren for å få tilgang til kilden.',
	'hideShowSummaries': 'Skjul/vis sammendrag',
	'crosstabName': 'Krysstabell',
	'value_is_not_available': 'Ikke tilgjengelig',
	'swapRowsAndColumns': 'Bytt rader og kolonner',
	'NoPinsCollected': 'Ingen festede visualiseringer',
	'pinSearchOld': 'Søk etter mine festede ressurser',
	'pinDeletedToast': 'Festet ressurs ble fjernet',
	'pinAddedToast': 'Festet ressurs ble lagt til i Mine festede ressurser',
	'pinRetrieveError': 'Kan ikke hente en eller flere festede ressurser. Prøv igjen senere.',
	'pinErrorTitle': 'Feil ved festing',
	'pinRemove': 'Fjern den festede ressursen',
	'deletePin': 'Slett den festede ressursen',
	'dataset_time': 'klokkeslett',
	'dataset_date': 'dato',
	'dataset_location': 'sted',
	'dataset_number': 'tall',
	'dataset_text': 'tekst',
	'widgetConditionalFormatLabel': 'Slå betingede formatkontroller på/av',
	'deletePinConfirmationMessage': 'Er du sikker på at du vil slette denne festede ressursen? Du kan ikke angre dette.',
	'deletePinConfirm': 'Bekreft sletting',
	'pinDeleteError': 'Kan ikke slette en eller flere festede ressurser. Prøv igjen senere.',
	'conditionalPalettePickerLabel': 'Distribusjon av %{title}-verdier',
	'HistogramYAxisTitle': 'Antall',
	'metadataPickerTitle': 'Opprett datasett',
	'moreTitle': 'Mer',
	'remove_slider_handle': 'Fjern håndtak',
	'missingFiltering': 'Kolonne mangler:',
	'unSupportedPromptType': 'Forespørselsscenariet støttes ikke nå.',
	'preAggregateLabel': 'Bruk forespørselsverdier fra datakilden',
	'postAggregateLabel': 'Bruk forespørselsverdier i rapporten',
	'preAggregateText': 'Området bruker verdiene i datakilden, ikke verdiene som blir vist på dashbordet.',
	'tabName_general': 'Generelt',
	'tabName_visDetails': 'Detaljer',
	'tabName_textDetails': 'Tekstdetaljer',
	'tabName_mediaDetails': 'Mediedetaljer',
	'tabName_webDetails': 'Websidedetaljer',
	'tabName_imageDetails': 'Bildedetaljer',
	'tabName_visualization': 'Visualisering',
	'sectionName_canvas': 'Lerret',
	'sectionName_colorsAndThemes': 'Farge og tema',
	'sectionName_appearance': 'Utseende',
	'sectionName_advanced': 'Avansert',
	'sectionName_layout': 'Layout',
	'sectionName_tabs': 'Flipper',
	'sectionName_tabTitle': 'Etikett',
	'sectionName_tabBackground': 'Bakgrunn',
	'addDataSourceDialogTitle': 'Legg til en datakilde',
	'addDataSourceDialogButtonLabel': 'Legg til',
	'shapesDoubleChevron': 'Dobbelt vinkel',
	'widgetsPanelTitle': 'Widgeter',
	'widgetsPanelImageLibraryTab': 'Bildebibliotek',
	'widgetsPanelSectionBasic': 'Grunnleggende',
	'widgetsPanelSectionAdvanced': 'Avansert',
	'widgetsPanelSectionShapes': 'Former',
	'customWidgetsTitle': 'Tilpassede widgeter',
	'filterItemCanvasMove': 'Legg til på lerret',
	'filterOverflowMenu_Global': 'Overflytmeny for alle flipper',
	'filterOverflowMenu_Tab': 'Overflytmeny for denne flippen',
	'filterOverflowMenu_Item': 'Overflytmeny for filter',
	'filterOverflowMenu_Single': 'Overflytmeny',
	'filterItemEdit': 'Rediger filterverdier',
	'filterDeleteAllItems': 'Slett alle filtre',
	'filterClearAllItems': 'Fjern alle filtre',
	'filterClearSelection': 'Fjern filter',
	'filterPlayerMode': 'Vis avspiller',
	'filterStaticMode': 'Vis liste',
	'filterInvertSelection': 'Inverter filter',
	'filterIconLabel_Global': 'Alle flipper',
	'filterIconLabel_Single': 'Filtre',
	'filterIconLabel_Tab': 'Denne flippen',
	'filterIconTooltip_Global': 'Alle flipper',
	'filterIconTooltip_Tab': 'Denne flippen',
	'filterIconTooltip_Single': 'Filtre',
	'filterItemDelete': 'Slett filter',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'alt unntatt: %{from}-%{to}',
	'filterExcept': 'unntatt %{values}',
	'filterAll': 'Alle',
	'filterBlank': '(tom)',
	'filterDisableRangeInvert': 'Ikke tilgjengelig når denne kolonnen er i filteret \'Alle flipper\'.',
	'filterDisableHierarchyInvert': 'Ikke tilgjengelig når denne kolonnen er i et hierarkifilter.',
	'filterSelectedOfTotal': '%{selected} av %{totalMembers}',
	'filter_date_before': 'Før %{to}',
	'filter_date_before_except': 'Ikke før %{to}',
	'filter_date_after': 'Etter %{from}',
	'filter_date_after_except': 'Ikke etter %{from}',
	'filter_date_between': 'Mellom %{from}-%{to}',
	'filter_date_between_except': 'Ikke mellom %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Dra og slipp data her for å filtrere alle flipper.',
	'filter_drag_and_drop_current_tab': 'Dra og slipp data her for å filtrere denne flippen.',
	'filter_drag_and_drop_single_dock': 'Dra og slipp data her for å filtrere.',
	'errMsgFilterItemGenericTitle': 'Filterverdier kan ikke lastes inn',
	'widgetChromeRotate': 'Roter',
	'toolbarRegionLabel': 'Verktøylinje',
	'toolbarActionDelete': 'Slett',
	'toolbarActionGroup': 'Gruppe',
	'toolbarActionUngroup': 'Opphev gruppering',
	'toolbarActionOrderToFront': 'Plasser lengst frem',
	'toolbarActionOrderToBack': 'Plasser lengst bak',
	'toolbarActionEditTitle': 'Rediger tittelen',
	'toolbarActionWrapTitle': 'Bryt tittelen',
	'toolbarActionPin': 'Samle inn',
	'toolbarActionPinOld': 'Fest',
	'toolbarActionAlign': 'Juster',
	'alignWidgetLeft': 'Venstre',
	'alignWidgetCenter': 'Midten',
	'alignWidgetRight': 'Høyre',
	'alignWidgetTop': 'Øverst',
	'alignWidgetMiddle': 'Midten',
	'alignWidgetBottom': 'Nederst',
	'toolbarChangeVisualization': 'Endre visualisering',
	'live_label': 'Diagram',
	'filter_label': 'Filter',
	'one_named_live': 'Diagrammet %{name}',
	'one_named_live_numbered': 'Diagrammet %{name} (%{number})',
	'one_unknown_live': 'Diagram',
	'one_unknown_live_numbered': 'Diagram (%{number})',
	'few_live': 'Gruppe med %{count} diagrammer',
	'many_live': 'Gruppe med %{count} diagrammer',
	'one_custom': 'Tilpasset widget',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Filteret %{name}',
	'one_named_filter_numbered': 'Filteret %{name} (%{number})',
	'one_unknown_filter': 'Filter',
	'one_unknown_filter_numbered': 'Filter (%{number})',
	'few_filter': 'Gruppe med %{count} filtre',
	'many_filter': 'Gruppe med %{count} filtre',
	'LIVE_bar_has_mapping': 'Stolpediagrammet %{values}',
	'LIVE_bar_has_mapping_numbered': 'Stolpediagrammet %{values} (%{number})',
	'LIVE_bar_opt_mapping': 'Stolpediagram med %{categories} og %{values}',
	'LIVE_bar_opt_mapping_numbered': 'Stolpediagram med %{categories} og %{values} (%{number})',
	'LIVE_bar_no_mapping': 'Tomt stolpediagram',
	'LIVE_bar_no_mapping_numbered': 'Tomt stolpediagram (%{number})',
	'LIVE_bar_named': 'Stolpediagrammet %{name}',
	'LIVE_bar_named_numbered': 'Stolpediagrammet %{name} (%{number})',
	'LIVE_stacked_bar_has_mapping': 'Det stablede stolpediagrammet %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Det stablede stolpediagrammet %{values} (%{number})',
	'LIVE_stacked_bar_opt_mapping': 'Stablet stolpediagram med %{categories} og %{values}',
	'LIVE_stacked_bar_opt_mapping_numbered': 'Stablet stolpediagram med %{categories} og %{values} (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Tomt stablet stolpediagram',
	'LIVE_stacked_bar_no_mapping_numbered': 'Tomt stablet stolpediagram (%{number})',
	'LIVE_stacked_bar_named': 'Det stablede stolpediagrammet %{name}',
	'LIVE_stacked_bar_named_numbered': 'Det stablede stolpediagrammet %{name} (%{number})',
	'LIVE_bubble_has_mapping': 'Boblediagram med %{categories} og %{x} og %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Boblediagram med %{categories} og %{x} og %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Tomt boblediagram',
	'LIVE_bubble_no_mapping_numbered': 'Tomt boblediagram (%{number})',
	'LIVE_bubble_named': 'Boblediagrammet %{name}',
	'LIVE_bubble_named_numbered': 'Boblediagrammet %{name} (%{number})',
	'LIVE_composite_has_mapping': 'Sammensatt diagram med %{categories} og %{columnValue} og %{lineValue}',
	'LIVE_composite_has_mapping_numbered': 'Sammensatt diagram med %{categories} og %{columnValue} og %{lineValue} (%{number})',
	'LIVE_composite_no_mapping': 'Tomt sammensatt diagram',
	'LIVE_composite_no_mapping_numbered': 'Tomt sammensatt diagram (%{number})',
	'LIVE_composite_named': 'Det sammensatte diagrammet %{name}',
	'LIVE_composite_named_numbered': 'Det sammensatte diagrammet %{name} (%{number})',
	'LIVE_decision_tree_has_mapping': 'Beslutningstre med %{values}',
	'LIVE_decision_tree_has_mapping_numbered': 'Beslutningstre med %{values} (%{number})',
	'LIVE_decision_tree_no_mapping': 'Tomt beslutningstre',
	'LIVE_decision_tree_no_mapping_numbered': 'Tomt beslutningstre (%{number})',
	'LIVE_decision_tree_named': 'Beslutningstreet %{name}',
	'LIVE_decision_tree_named_numbered': 'Beslutningstreet %{name} (%{number})',
	'LIVE_packed_bubble_has_mapping': 'Pakket boblediagram med %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Pakket boblediagram med %{categories} (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Tomt pakket boblediagram',
	'LIVE_packed_bubble_no_mapping_numbered': 'Tomt pakket boblediagram (%{number})',
	'LIVE_packed_bubble_named': 'Det pakkede boblediagrammet %{name}',
	'LIVE_packed_bubble_named_numbered': 'Det pakkede boblediagrammet %{name} (%{number})',
	'LIVE_pie_has_mapping': 'Sektordiagram med %{categories} og %{values}',
	'LIVE_pie_has_mapping_numbered': 'Sektordiagram med %{categories} og %{values} (%{number})',
	'LIVE_pie_no_mapping': 'Tomt sektordiagram',
	'LIVE_pie_no_mapping_numbered': 'Tomt sektordiagram (%{number})',
	'LIVE_pie_named': 'Sektordiagrammet %{name}',
	'LIVE_pie_named_numbered': 'Sektordiagrammet %{name} (%{number})',
	'LIVE_pie_as_donut_has_mapping': 'Smultringdiagram med %{categories} og %{values}',
	'LIVE_pie_as_donut_has_mapping_numbered': 'Smultringdiagram med %{categories} og %{values} (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Tomt smultringdiagram',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Tomt smultringdiagram (%{number})',
	'LIVE_pie_as_donut_named': 'Smultringdiagrammet %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Smultringdiagrammet %{name} (%{number})',
	'LIVE_line_has_mapping': 'Linjediagram med %{categories} og %{values}',
	'LIVE_line_has_mapping_numbered': 'Linjediagram med %{categories} og %{values} (%{number})',
	'LIVE_line_no_mapping': 'Tomt linjediagram',
	'LIVE_line_no_mapping_numbered': 'Tomt linjediagram (%{number})',
	'LIVE_line_named': 'Linjediagrammet %{name}',
	'LIVE_line_named_numbered': 'Linjediagrammet %{name} (%{number})',
	'LIVE_area_has_mapping': 'Arealdiagram med %{categories} og %{values}',
	'LIVE_area_has_mapping_numbered': 'Arealdiagram med %{categories} og %{values} (%{number})',
	'LIVE_area_no_mapping': 'Tomt arealdiagram',
	'LIVE_area_no_mapping_numbered': 'Tomt arealdiagram (%{number})',
	'LIVE_area_named': 'Arealdiagrammet %{name}',
	'LIVE_area_named_numbered': 'Arealdiagrammet %{name} (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': 'Stablet prosentarealdiagram med %{categories} og %{values}',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': 'Stablet prosentarealdiagram med %{categories} og %{values} (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Tomt stablet prosentarealdiagram',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Tomt stablet prosentarealdiagram (%{number})',
	'LIVE_area_as_stacked_percent_named': 'Det stablede prosentarealdiagramet %{name}',
	'LIVE_area_as_stacked_percent_named_numbered': 'Det stablede prosentarealdiagrammet %{name} (%{number})',
	'LIVE_heatmap_has_mapping': 'Varmekartet %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Varmekartet %{color} (%{number})',
	'LIVE_heatmap_no_mapping': 'Tomt varmekart',
	'LIVE_heatmap_no_mapping_numbered': 'Tomt varmekart (%{number})',
	'LIVE_heatmap_named': 'Varmekartet %{name}',
	'LIVE_heatmap_named_numbered': 'Varmekartet %{name} (%{number})',
	'LIVE_network_opt_mapping': 'Nettverk med %{categories} og %{series} og %{values}',
	'LIVE_network_opt_mapping_numbered': 'Nettverk med %{categories} og %{series} og %{values} (%{number})',
	'LIVE_network_has_mapping': 'Nettverk med %{categories} og %{series}',
	'LIVE_network_has_mapping_numbered': 'Nettverk med %{categories} og %{series} (%{number})',
	'LIVE_network_no_mapping': 'Tomt nettverk',
	'LIVE_network_no_mapping_numbered': 'Tomt nettverk (%{number})',
	'LIVE_network_named': 'Nettverket %{name}',
	'LIVE_network_named_numbered': 'Nettverket %{name} (%{number})',
	'LIVE_radial_bar_opt_mapping': 'Strålestolpediagram med %{categories} og %{values}',
	'LIVE_radial_bar_opt_mapping_numbered': 'Strålestolpediagram med %{categories} og %{values} (%{number})',
	'LIVE_radial_bar_has_mapping': 'Strålestolpediagrammet %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Strålestolpediagrammet %{values} (%{number})',
	'LIVE_radial_bar_no_mapping': 'Tomt strålestolpediagram',
	'LIVE_radial_bar_no_mapping_numbered': 'Tomt strålestolpediagram (%{number})',
	'LIVE_radial_bar_named': 'Strålestolpediagrammet %{name}',
	'LIVE_radial_bar_named_numbered': 'Strålestolpediagrammet %{name} (%{number})',
	'LIVE_spiral_has_mapping': 'Spiraldiagram for %{values}',
	'LIVE_spiral_has_mapping_numbered': 'Spiraldiagram for %{values} (%{number})',
	'LIVE_spiral_no_mapping': 'Tomt spiraldiagram',
	'LIVE_spiral_no_mapping_numbered': 'Tomt spiraldiagram (%{number})',
	'LIVE_spiral_named': 'Spiraldiagrammet %{name}',
	'LIVE_spiral_named_numbered': 'Spiraldiagrammet %{name} (%{number})',
	'LIVE_treemap_has_mapping': 'Trekart med %{categories} og %{size}',
	'LIVE_treemap_has_mapping_numbered': 'Trekart med %{categories} og %{size} (%{number})',
	'LIVE_treemap_no_mapping': 'Tomt trekart',
	'LIVE_treemap_no_mapping_numbered': 'Tomt trekart (%{number})',
	'LIVE_treemap_named': 'Trekartet %{name}',
	'LIVE_treemap_named_numbered': 'Trekartet %{name} (%{number})',
	'LIVE_wordcloud_has_mapping': 'Ordsky med %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Ordsky med %{categories} (%{number})',
	'LIVE_wordcloud_no_mapping': 'Tom ordsky',
	'LIVE_wordcloud_no_mapping_numbered': 'Tom ordsky (%{number})',
	'LIVE_wordcloud_named': 'Ordskyen %{name}',
	'LIVE_wordcloud_named_numbered': 'Ordskyen %{name} (%{number})',
	'LIVE_data_player_has_mapping': 'Dataavspiller med %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Dataavspiller med %{category} (%{number})',
	'LIVE_data_player_no_mapping': 'Tom dataspiller',
	'LIVE_data_player_no_mapping_numbered': 'Tom dataavspiller (%{number})',
	'LIVE_data_player_named': 'Dataavspilleren %{name}',
	'LIVE_data_player_named_numbered': 'Dataavspilleren %{name} (%{number})',
	'LIVE_map_has_mapping': 'Kart for %{locations}',
	'LIVE_map_has_mapping_numbered': 'Kart for %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Tomt kart',
	'LIVE_map_no_mapping_numbered': 'Tomt kart (%{number})',
	'LIVE_map_named': 'Kartet %{name}',
	'LIVE_map_named_numbered': 'Kartet %{name} (%{number})',
	'LIVE_point_has_mapping': 'Punktdiagram med %{categories} og %{values}',
	'LIVE_point_has_mapping_numbered': 'Punktdiagram med %{categories} og %{values} (%{number})',
	'LIVE_point_no_mapping': 'Tomt punktdiagram',
	'LIVE_point_no_mapping_numbered': 'Tomt punktdiagram (%{number})',
	'LIVE_point_named': 'Punktdiagrammet %{name}',
	'LIVE_point_named_numbered': 'Punktdiagrammet %{name} (%{number})',
	'LIVE_column_has_mapping': 'Kolonnediagrammet %{values}',
	'LIVE_column_has_mapping_numbered': 'Kolonnediagrammet %{values} (%{number})',
	'LIVE_column_opt_mapping': 'Kolonnediagram med %{categories} og %{values}',
	'LIVE_column_opt_mapping_numbered': 'Kolonnediagram med %{categories} og %{values} (%{number})',
	'LIVE_column_no_mapping': 'Tomt kolonnediagram',
	'LIVE_column_no_mapping_numbered': 'Tomt kolonnediagram (%{number})',
	'LIVE_column_named': 'Kolonnediagrammet %{name}',
	'LIVE_column_named_numbered': 'Kolonnediagrammet %{name} (%{number})',
	'LIVE_stacked_column_has_mapping': 'Det stablede kolonnediagrammet %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Det stablede kolonnediagrammet %{values} (%{number})',
	'LIVE_stacked_column_opt_mapping': 'Stablet kolonnediagram med %{categories} og %{values}',
	'LIVE_stacked_column_opt_mapping_numbered': 'Stablet kolonnediagram med %{categories} og %{values} (%{number})',
	'LIVE_stacked_column_no_mapping': 'Tomt stablet kolonnediagram',
	'LIVE_stacked_column_no_mapping_numbered': 'Tomt stablet kolonnediagram (%{number})',
	'LIVE_stacked_column_named': 'Det stablede kolonnediagrammet %{name}',
	'LIVE_stacked_column_named_numbered': 'Det stablede kolonnediagrammet %{name} (%{number})',
	'LIVE_scatter_opt_mapping': 'Spredningsdiagram med %{categories} og %{x} og %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Spredningsdiagram med %{categories} og %{x} og %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Spredningsdiagram med %{x} mot %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Spredningsdiagram med %{x} mot %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Tomt spredningsdiagram',
	'LIVE_scatter_no_mapping_numbered': 'Tomt spredningsdiagram (%{number})',
	'LIVE_scatter_named': 'Spredningsdiagrammet %{name}',
	'LIVE_scatter_named_numbered': 'Spredningsdiagrammet %{name} (%{number})',
	'LIVE_waterfall_has_mapping': 'Fossediagrammet %{values}',
	'LIVE_waterfall_has_mapping_numbered': 'Fossediagrammet %{values} (%{number})',
	'LIVE_waterfall_no_mapping': 'Tomt fossediagram',
	'LIVE_waterfall_no_mapping_numbered': 'Tomt fossediagram (%{number})',
	'LIVE_waterfall_named': 'Fossediagrammet %{name}',
	'LIVE_waterfall_named_numbered': 'Fossediagrammet %{name} (%{number})',
	'LIVE_empty_visualization_hint_title': 'Bygg visualiseringen din',
	'LIVE_empty_visualization_hint_description': 'Dra og slipp kolonner her eller i sporene til venstre.',
	'LIVE_slots_required_field_description': '%{asterisk} Angir et obligatorisk felt',
	'LIVE_slots_drag_and_drop_description': 'Dra og slipp data i sporene ovenfor for å bygge og filtrere visualiseringen.',
	'requiredField': 'Obligatorisk felt',
	'fullScreenEnter': 'Gå til full skjerm',
	'fullScreenClose': 'Avslutt full skjerm',
	'noExtraText_multipurpose': 'Flerfunksjonsplassholder',
	'noExtraText_multipurpose_numbered': 'Flerfunksjonsplassholder (%{number})',
	'one_placeholder_vis': 'Visualiseringsplassholder',
	'one_placeholder_vis_numbered': 'Visualiseringsplassholder (%{number})',
	'one_placeholder_text': 'Tekstplassholder',
	'one_placeholder_text_numbered': 'Tekstplassholder (%{number})',
	'few_placeholder_text': 'Gruppe med %{count} tekstplassholdere',
	'many_placeholder_text': 'Gruppe med %{count} tekstplassholdere',
	'filter_includesAll': 'Inkluderer alle',
	'timeline_filter_moved_to': 'Tidlinjefilter %{id} flyttet til %{time}',
	'timelineSettingsButton': 'Alternativer for avspilling',
	'autoPlay': 'Spill av alle scener',
	'loop': 'Sløyfe',
	'noSceneTransitionLabel': 'Ingen',
	'sceneTransitionPropertyLabel': 'Sceneovergang',
	'animatedPathSceneTransitionLabel': 'Animert bane',
	'sweepSceneTransitionLabel': 'Sveip',
	'propAniAnimation': 'Animasjon',
	'propAniTypeEntrance': 'Inngangsanimasjon',
	'propAniDirectionIn': 'Inngangsretning',
	'propAniTypeExit': 'Utgangsanimasjon',
	'propAniDirectionOut': 'Utgangsretning',
	'propAniDirection': 'Retning',
	'timelineAnimationProperties': 'Åpne animasjonsegenskaper',
	'editStoryCoachMarkTitle': 'Rediger historie',
	'editStoryCoachMarkContents': 'Klikk på blyantikonet for å redigere denne historien.',
	'addDataStoryCoachMarkContents': 'Dra og slipp data fra datapanelet til historien.',
	'expandSceneCoachmarkTitle': 'Åpne tidslinje',
	'expandSceneCoachmarkContents': 'Animer en scene ved å justere objektsynligheten basert på tid og varighet.',
	'overviewCoachmarkTitle': 'Oversiktsscener',
	'overviewCoachmarkContents': 'Bruk oversiktsscenene på begynnelsen og slutten av historien for å vise det overordnede bildet for alle scenene. Fra en oversiktsscene klikker og drar du en scene for å bytte den med en annen scene. Du kan vise eller skjule oversiktsscenene i historieegenskapene.',
	'animatedPathCoachmarkTitle': 'Animert bane',
	'animatedPathCoachmarkContents': 'Hvis du vil animere et objekt fra en scene til en annen, dupliserer du en scene med et objekt. Deretter flytter du, endrer størrelse eller roterer du det dupliserte objektet i den nye scenen.',
	'tabName_animation': 'Animasjon',
	'textWidgetIconPlaceholderText': 'Klikk for å legge til tekst',
	'visIconPlaceholderText': 'Dra og slipp data for å bygge en visualisering',
	'launchNewExplore': 'Ny utforsking',
	'addTo': 'Legg til i',
	'addToExisting': 'Legg til i eksisterende...',
	'exploreData': 'Utforsk',
	'explore_remove_widget_styles': 'Tilpassede visualiseringsegenskaper, for eksempel fargeinnstillinger, vil ikke bli bevart i utforskingen.',
	'editNotebook': 'Rediger widget',
	'thumbnails_error_fetching': 'Feil ved henting av miniatyrbilder',
	'copy': '%{count} ressurs(er) kopiert',
	'specConvertErr': 'Det oppstod en feil ved innliming eller konvertering av dashbordspesifikasjonen',
	'specCopyErr': 'Feil ved kopiering av dashbordspesifikasjon',
	'pasteNotSupportedErr': 'Innliming fra en %{name} støttes ikke.',
	'reportParam': 'rapport',
	'filterWidgetCopyWarn': 'Filtervisualisering ble ikke kopiert fordi Filtre ikke støttes nå.',
	'upgradingDashboard': 'Oppgraderer \'%{name}\' for %{version}...',
	'upgradeComplete': 'Oppgradering fullført',
	'individualTabProperties': 'Individuelle flippegenskaper',
	'propMasterTabStylesLabel': 'Stil for hovedflipp',
	'propTabPosition': 'Flipp-posisjon',
	'propTabTitle': 'Tittel',
	'propTabBackgroundColor': 'Fyllfarge',
	'propTabTextColor': 'Tittelfarge',
	'propTabSelectedBarColor': 'Valgt stolpefarge',
	'propTabRestoreDefaults': 'Bruk standardverdier',
	'propIndividualTabStylesLabel': 'Individuell flippstil',
	'propIndividualTabStylesAriaLabel': 'Åpne egenskaper for individuell flippstil',
	'propTabIconPosition': 'Ikonposisjon',
	'propLeftTitle': 'Til venstre for tittel',
	'propRightTitle': 'Til høyre for tittel',
	'propTopTitle': 'Over tittel',
	'propBottomTitle': 'Under tittel',
	'propTabIconLabel': 'Visuell',
	'propTabIcon': 'Ikon',
	'propTabIconColor': 'Ikonfarge',
	'no_icon': 'Tomt',
	'announcement': 'Kunngjøring',
	'api': 'Api',
	'archive': 'Arkiv',
	'asset': 'Ressurs',
	'attachment': 'Vedlegg',
	'audio': 'Lyd',
	'bee': 'Bie',
	'blog': 'Blogg',
	'bookmark': 'Bokmerke',
	'calendar': 'Kalender',
	'camera': 'Kamera',
	'capability': 'Egenskap',
	'catalog': 'Katalog',
	'chat_message': 'Samtalemelding',
	'checkout_cart': 'Handlekurv',
	'client': 'Klient',
	'clock': 'Klokke',
	'cloud': 'Sky',
	'code': 'Kode',
	'data_quality': 'Datakvalitet',
	'folder': 'Mapper',
	'forum': 'Forum',
	'glasses': 'Briller',
	'group': 'Gruppe',
	'hat': 'Hatt',
	'headphone': 'Hodetelefon',
	'hills': 'Åser',
	'home': 'Hjem',
	'idea': 'Idé',
	'image': 'Bilde',
	'inventory': 'Inventar',
	'like': 'Liker',
	'link': 'Link',
	'location': 'Plassering',
	'manage': 'Administrer',
	'pen': 'Penn',
	'mobile_phone': 'Mobiltelefon',
	'music': 'Musikk',
	'notifications': 'Meldinger',
	'paint': 'Mal',
	'payment': 'Betaling',
	'password_key': 'Passordnøkkel',
	'people': 'Mennesker',
	'person': 'Person',
	'phone': 'Telefon',
	'pin': 'Fest',
	'print': 'Skriv ut',
	'recording': 'Innspilling',
	'repository': 'Datalager',
	'role': 'Rolle',
	'search': 'Søk',
	'properties': 'Egenskaper',
	'speaker': 'Høyttaler',
	'star': 'Stjerne',
	'tag': 'Kode',
	'thumbs_up': 'Tommel opp',
	'thumbs_down': 'Tommel ned',
	'tools': 'Verktøy',
	'traffic': 'Trafikk',
	'trash': 'Papirkurv',
	'twitter': 'Twitter',
	'unknown': 'Ukjent',
	'user': 'Bruker',
	'venn_diagram': 'Venndiagram',
	'video': 'Video',
	'view': 'Vis',
	'warning': 'Advarsel',
	'watch': 'Overvåk',
	'watson': 'Watson',
	'wikis': 'Wikier',
	'workspace': 'Arbeidsområde',
	'world': 'Verden',
	'OnLoadFilterModifierDatasourceMismatch': 'Filtre vil ikke bli brukt på målet fordi dashbordene bruker ulike kilder.',
	'OnLoadFilterModifierColumnMismatch': 'Ett eller flere filtre ble ikke tatt i bruk fordi den eller de samsvarende kolonnene ikke ble funnet.',
	'eventGroupButtonLabel': 'Vis widgettilkoblinger',
	'dockToolbar': 'Dokk verktøylinje',
	'undockToolbar': 'Dokk ut verktøylinje',
	'propShowTitle': 'Vis tittel'
});
